export const SDContact = {
  //   email: 'support@marihub.net',
  //   phone: '+971588796386',
  //   faq: 'http://help.marihub.com/',
  //   calendly: 'https://outlook.office365.com/owa/calendar/Marihub@marihub.net/bookings/',
  //   salesCal: 'https://outlook.office365.com/owa/calendar/MarihubSalesInquiries@marihub.net/bookings/'
  // }
  email: "support@marihub.net",
  phone: "+971588796386",
  faq: "http://help.marihub.com/",
  calendly:
    "https://outlook.office365.com/owa/calendar/Marihub@marihub.net/bookings/",
  salesCal:
    "https://outlook.office365.com/owa/calendar/MarihubSalesInquiries@marihub.net/bookings/",
};
